module.exports = __webpack_public_path__ + "img/07.100445f6.jpg";